// import axios from "axios";
// import { GET_PROFILE_DETAILS, GET_PROFILE_PERCENTAGE, POST_EDIT_PROFILE } from "../../utils/api";
// import { EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILURE, PROFILE_DETAILS_FAILURE, PROFILE_DETAILS_SUCCESS, PROFILE_COMPLETION_SUCCESS, PROFILE_COMPLETION_FAILURE} from "./profile.actionTypes";

// export const editProfile = (payLoad) => async (dispatch) => {
//   const token = localStorage.getItem("access_token") || null;
//     const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.put(POST_EDIT_PROFILE, payLoad, {
//       headers,
//       withCredentials: true,
//     });
    
//     if (resp.status === 200) {
//       // dispatch({
//       //   type: EDIT_PROFILE_SUCCESS,
//       //   payload: { data: resp.data },
//       // });
//       return { success: true };
//     } else {
//       // dispatch({
//       //   type: EDIT_PROFILE_FAILURE,
//       //   payload: { message: resp?.data},
//       // });
//       return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//     // const errorMsg = error?.message || "Something went wrong";
  
//     // dispatch({
//     //   type: EDIT_PROFILE_FAILURE,
//     //   payload: { message: errorMsg },
//     // });
//     return { success: false, message: errorMsg };
//   }
// };

// export const profileDetails = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_PROFILE_DETAILS, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: PROFILE_DETAILS_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: PROFILE_DETAILS_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: PROFILE_DETAILS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const profileCompletionPercentage = () => async (dispatch) => {
//   const token = localStorage.getItem("access_token");
//   const headers = { Authorization: `Bearer ${token}` };

//   try {
//     const resp = await axios.get(GET_PROFILE_PERCENTAGE, { headers, withCredentials: true });
//     if (resp.status === 200) {
//       dispatch({ type: PROFILE_COMPLETION_SUCCESS, payload: resp.data });
//       return resp.data; // Return value to use in handleLogin
//     } else {
//       dispatch({ type: PROFILE_COMPLETION_FAILURE, payload: { message: resp?.data?.msg } });
//       return null;
//     }
//   } catch (error) {
//     dispatch({ type: PROFILE_COMPLETION_FAILURE, payload: { message: error } });
//     return null;
//   }
// };


import { apiRequest } from "../../api/apiRequest";
import { GET_PROFILE_DETAILS, GET_PROFILE_PERCENTAGE, POST_EDIT_PROFILE } from "../../utils/api";
import { EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILURE, PROFILE_DETAILS_FAILURE, PROFILE_DETAILS_SUCCESS, PROFILE_COMPLETION_SUCCESS, PROFILE_COMPLETION_FAILURE} from "./profile.actionTypes";

export const editProfile = (payLoad) => async (dispatch) => {
  const result = await apiRequest("put", POST_EDIT_PROFILE, payLoad);

  if (result.success) {
    dispatch({
      type: EDIT_PROFILE_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  } else {
    dispatch({
      type: EDIT_PROFILE_FAILURE,
      payload: { message: result.message },
    });
    return { success: false, message: result.message };
  }
};

export const profileDetails = () => async (dispatch) => {
  const result = await apiRequest("get", GET_PROFILE_DETAILS);

  if (result.success) {
    dispatch({
      type: PROFILE_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: PROFILE_DETAILS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const profileCompletionPercentage = () => async (dispatch) => {
  const result = await apiRequest("get", GET_PROFILE_PERCENTAGE);

  if (result.success) {
    dispatch({ type: PROFILE_COMPLETION_SUCCESS, payload: result.data });
    return result.data; // Return value to use in handleLogin
  } else {
    dispatch({ type: PROFILE_COMPLETION_FAILURE, payload: { message: result.message } });
    return null;
  }
};
